import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class TombOfAkhenatenBackgroundView extends BaseView {
    private _reelsFrame: PIXI.Sprite;
    private _reelsFrameGold: PIXI.Sprite;
    private _fsLeftContainer: PIXI.Container;
    private _fsLeftText: BitmapCountUp;
    private _gameMode: string;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    private _deviceOrientation: string = Orientation.PORTRAIT;

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event: GameModeEvent) => this.onModeChange(event.params[0].newMode));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_SPINS_LEFT_METER, (event: GameEvent) => this.updateSpinsLeft(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.SHOW_AWARDED_SPINS, () => this.addFreeSpins());
    }

    protected initAnimations(): void {
        const gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance,
            reelsFrameYPos: number = 370;

        let reelsFrameLayer: ScalableLayer = StageManager.getLayer(gameConfig.LAYERS.REELS_FRAME.name),
            reelBGLayer: ScalableLayer = StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name);

        this._reelsFrame = new PIXI.Sprite(GameResources.getTextures("reelFrame")[0]);
        this._reelsFrame.name = "reelFrame";
        this._reelsFrame.anchor.set(0.5);
        this._reelsFrame.position.set((gameConfig.REEL_AREA_WIDTH / 2) + 1, reelsFrameYPos);

        this._reelsFrameGold = new PIXI.Sprite(GameResources.getTextures("reelFrameGold")[0]);
        this._reelsFrameGold.name = "reelFrameGold";
        this._reelsFrameGold.anchor.set(0.5);
        this._reelsFrameGold.position.set((gameConfig.REEL_AREA_WIDTH / 2) + 1, reelsFrameYPos);
        this._reelsFrameGold.visible = false;

        let reelBG: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("reelBackground")[0]);
        reelBG.anchor.set(0.5);
        reelBG.position.set(gameConfig.REEL_AREA_WIDTH / 2, ((gameConfig.REEL_AREA_HEIGHT / 2) + gameConfig.JACKPOT_HEIGHT));

        let fsLeftLandscape: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsLeftLandscape")[0]);
        fsLeftLandscape.name = "fsLeftLandscape";
        fsLeftLandscape.anchor.set(0.5);
        fsLeftLandscape.position.set(-58, 68);

        this._fsLeftText = new BitmapCountUp({style: TombOfAkhenatenTextStyles.BONUS_GAME_MULTIPLIER});
        this._fsLeftText.pivot.set((this._fsLeftText.width / this._fsLeftText.text.length), this._fsLeftText.height / 2);
        this._fsLeftText.name = "fsLeftText";

        this._fsLeftContainer = new PIXI.Container();
        this._fsLeftContainer.name = "fsLeftContainer";
        this._fsLeftContainer.addChild(fsLeftLandscape, this._fsLeftText);

        let extraRopesContainer: PIXI.Container = new PIXI.Container;
        let ropeExtentionTexture = GameResources.getTextures("ropeExtention")[0];

        let ropeExtentionLeft: PIXI.Sprite = new PIXI.Sprite(ropeExtentionTexture);
        ropeExtentionLeft.anchor.set(0.5);
        ropeExtentionLeft.position.set(70, -90);

        let ropeExtentionRight: PIXI.Sprite = new PIXI.Sprite(ropeExtentionTexture);
        ropeExtentionRight.anchor.set(0.5);
        ropeExtentionRight.scale.set(-1, 1);
        ropeExtentionRight.position.set(650, -90);

        extraRopesContainer.addChild(ropeExtentionLeft, ropeExtentionRight);

        reelsFrameLayer.addChild(this._reelsFrame, this._reelsFrameGold, this._fsLeftContainer);
        reelBGLayer.addChild(extraRopesContainer, reelBG);
    }

    protected onResize(resizeData: IResizeData) {
        super.onResize && super.onResize(resizeData);

        this._deviceOrientation = resizeData.orientation;

        this.fsLeftContainerVisibility();
    }

    private addFreeSpins(): void{
        if(this.isBonusGame()){
            let updatedFreeSpinCount: number = parseInt(this._fsLeftText.text) + 1;
            this.updateSpinsLeft(updatedFreeSpinCount);
            SlotGame.keypad.setZeroBetSpinCounter(updatedFreeSpinCount);
        }
    }

    private updateSpinsLeft(fsCount?: number): void{
        let fsLeftCount = fsCount ? fsCount : this._gameData.freespinsLeft - 1;
        if(fsLeftCount < 0){
            fsLeftCount = 0;
        }
        this._fsLeftText.text = fsLeftCount.toString();
        this.applyScaling();
    }

    private isBonusGame(): boolean {
        let flag = false;
        if (TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameMode) > -1) {
            flag = true;
        }
        return flag;
    }

    private onDataParsed(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
    }

    private applyScaling(): void {
        let textW = this._fsLeftText.textWidth,
            posX: number,
            scaleValue: number;

        if (textW > 70) {
            scaleValue = 0.8;
            posX = -65;
        } else if (textW > 35) {
            scaleValue = 1;
            posX = -55;
        } else {
            scaleValue = 1;
            posX = -45;
        }
        this._fsLeftText.scale.set(scaleValue);
        this._fsLeftText.position.set(posX, 50);
    }

    private onModeChange(mode: string): void {
        this._gameMode = mode;

        if (this.isBonusGame()) {
            this._reelsFrame.visible = false;
            this._reelsFrameGold.visible = true;

            if(TombOfAkhenatenGameConfig.instance.GAME_RESTORED ||
                ((TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.mode) === -1) &&
                    (TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameData.nextMode) > -1))){
                this.updateSpinsLeft(this._gameData.freespinsLeft);
            }
        } else {
            this._reelsFrame.visible = true;
            this._reelsFrameGold.visible = false;
        }

        this.fsLeftContainerVisibility();
    }

    private fsLeftContainerVisibility(): void{
        if(this.isBonusGame()){
            this._fsLeftContainer.visible = this._deviceOrientation === "landscape";
        }else{
            this._fsLeftContainer.visible = false;
        }
    }
}